import React from 'react';
import { useReactToPrint } from 'react-to-print';
type Props = {
  customerContent: () => React.ReactInstance | null;
  staffContent: () => React.ReactInstance | null;
  ownerContent: () => React.ReactInstance | null;
  customPrintStaffReceipt?: () => void;
};
const usePrintOwnerReceiptWithStaff = ({ ownerContent, staffContent, customPrintStaffReceipt }: Props) => {

  const doPrintStaffReceipt = customPrintStaffReceipt || useReactToPrint({
    content: () => staffContent(),
  });

  const doPrintOwnerReceipt = useReactToPrint({
    content: () => ownerContent(),
    onAfterPrint: () => doPrintStaffReceipt(),
  });

  return doPrintOwnerReceipt;
};

export default usePrintOwnerReceiptWithStaff;
